// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"f644cc58","394":"7bf662b8","1897":"7bf662b8","4176":"3b53517f"}[chunkId] + ".chunk.css";
};